import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { OrderApiConfiguration } from '../order-api-configuration/app.constant.service';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';

@Injectable()

export class PackageCategoryService extends ServiceBase {

    private actionUrl: string;
    private url: string;

    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
        this.url = this.actionUrl + _configuration.packageCategory.url;
    }

    public getPackageCategoryBySearch = (filter: any): Observable<any[]> => {
        let params = new HttpParams();

        params = params.set('PackageId', filter.PackageId.toString());

        if (filter.CategoryId !== null && filter.CategoryId !== undefined) {
            params = params.set('CategoryId', filter.CategoryId.toString());
        }

        if (filter.Amount !== null && filter.Amount !== undefined && filter.Amount !== '') {
            params = params.set('Amount', filter.Amount.toString());
        }

        if (filter.IsActive !== null && filter.IsActive !== undefined) {
            params = params.set('IsActive', filter.IsActive.toString());
        }

        if (filter.CategoryTitle && filter.CategoryTitle.trim() !== '') {
            params = params.set('CategoryTitle', filter.CategoryTitle.trim());
        }

        return this._http.get<any[]>(`${this.url}/BySearch`, { params });
    }

    add(packageCategory: any) {
        return this._http.post<any>(this.url, packageCategory);
    }

    update(packageCategory: any) {
        return this._http.put<any>(this.url, packageCategory);
    }

}